export default "__VITE_ASSET__CbZEkmrj__"